import React from 'react';
import PropTypes from 'prop-types';
import {
  SearchDropdown, HealthChart, PaperCard, ColorIndicators, Skeleton,
} from '@iris-platform/iris-react-ui';
import withStyles from '@material-ui/core/styles/withStyles';
import { Chip } from '@material-ui/core';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

const styles = () => ({
  pageWrapper: {
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  cardHeader: {
    padding: '0 15px',
  },
  card: {
    overflowX: 'auto',
  },
  healthIndicesWrapper: {
    textAlign: 'right',
    margin: '10px 5px',
  },
  chartWrapper: {
    marginTop: '30px',
    boxShadow: '1px 1px 10px #999',
  },
  healthCardWrapper: {
    marginBottom: '25px',
  },
  chip: {
    margin: '5px',
  },
});

const GET_ALL_SERVICES = gql`
  {
    getHealthServices
  }
`;

const GET_HEALTH = gql`
query getHealth ($envn:String!, $server: String!, $time: String!){
  getHealth(envn: $envn, server:$server, time:$time){
  env,
  servertype,
  avg,
  time_bucket,
  objectId,
  createdAt
  updatedAt
}
}`;


const HistoricalData = (props) => {
  const {
    classes,
    onSelect,
    filteredServers,
    handleDelete,
    timeAgo,
    getTransformedData,
    getTooltipData,
    getBarColors,
  } = props;
  return (
    <div className={classes.pageWrapper}>
      <Query query={GET_ALL_SERVICES} notifyOnNetworkStatusChange>
        {({ data, loading, error }) => {
          if (error) {
            return <h1>Oops, got error...</h1>;
          }
          return (data && data.getHealthServices && !loading
            ? (
              <SearchDropdown
                optionsList={data.getHealthServices.map(item => (
                  { code: item, description: item }))}
                placeholder="Please select your services"
                onSelect={onSelect}
              />
            )
            : <Skeleton />);
        }}
      </Query>
      <div className={classes.chipContainer}>
        {
          filteredServers.map(item => (
            <Chip
              key={Math.random()}
              label={item.description}
              onDelete={() => handleDelete(item)}
              className={classes.chip}
            />
          ))
        }
      </div>

      <div className={classes.chartWrapper} id={timeAgo.value}>
        {
          filteredServers.map((item, i) => (
            <Query
              key={Math.random()}
              query={GET_HEALTH}
              variables={{
                envn: 'sdk',
                server: item.description,
                time: timeAgo.value,
              }}
            >

              {({ data, loading, error }) => {
                if (error) {
                  return <h1>Oops, got error...</h1>;
                }
                const chartData = data && data.getHealth && !loading
                  ? getTransformedData(data.getHealth, timeAgo, item) : [];
                return (
                  <div className={classes.healthCardWrapper}>
                    <PaperCard title={item.description} subtitle={`Past ${timeAgo.label}`} classes={{ cardHeader: classes.cardHeader, card: classes.card }}>
                      <div className={classes.healthIndicesWrapper}>
                        <ColorIndicators />
                      </div>
                      {chartData.length
                        ? (
                          <HealthChart
                            chartId={`historicalHealth-${i}`}
                            data={chartData}
                            getTooltipData={getTooltipData}
                            getBarColors={getBarColors}
                          />
                        )
                        : <Skeleton />
                      }
                    </PaperCard>

                  </div>
                );
              }}
            </Query>
          ))
        }
      </div>

    </div>
  );
};

export default withStyles(styles)(HistoricalData);

HistoricalData.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  filteredServers: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleDelete: PropTypes.func.isRequired,
  timeAgo: PropTypes.objectOf(PropTypes.string).isRequired,
  getTransformedData: PropTypes.func.isRequired,
  getTooltipData: PropTypes.func.isRequired,
  getBarColors: PropTypes.func.isRequired,
};
